export default {
      id: "trashcan-usage",
      viewBox: "0 0 20.2 24",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#trashcan",
      toString: function () {
        return this.url;
      }
    }